import { LayoutDashboard, Table2, Crosshair, Swords, Upload, Settings, Trophy, Building2, Gauge, ClipboardList, UploadCloud, Medal, Wrench, BarChart3, Clock, Users, Target, Boxes, Warehouse, PackageSearch, Landmark, Zap, Compass } from "lucide-react";

export const canUploadStock = (u) => !!u && (u.role === "admin" || u.role === "accounts");
export const canUploadRetail = (u) => !!u && (["admin", "accounts", "stock"].includes(u.role) || (u.role === "vp" && u.department === "sales"));
export const canCurateStock = (u) => !!u && ["admin", "accounts", "stock"].includes(u.role);
export const isStockIncharge = (u) => !!u && u.role === "stock";
export const canEditBanks = (u) => !!u && (u.role === "admin" || u.role === "accounts" || (u.role === "vp" && u.department === "sales"));

export const NAV = [
  { to: "/", label: "Command Center", icon: LayoutDashboard, end: true, mod: "mis" },
  { to: "/rtos", label: "RTO Explorer", icon: Table2, mod: "mis" },
  { to: "/focus", label: "Focus Markets", icon: Crosshair, mod: "mis" },
  { to: "/brandwars", label: "Brand Wars", icon: Swords, mod: "mis" },
  { to: "/league", label: "RTO League", icon: Trophy, mod: "common" },
  { to: "/branches", label: "Branches", icon: Building2, mod: "common" },
  { to: "/dpc/overview", label: "Group Overview", icon: Compass, mod: "dpc" },
  { to: "/dpc", label: "DPC Cockpit", icon: Gauge, end: true, mod: "dpc" },
  { to: "/dpc/plans", label: "DPC Plans", icon: ClipboardList, mod: "dpc" },
  { to: "/dpc/league", label: "DPC League", icon: Medal, mod: "dpc" },
  { to: "/dpc/upload", label: "DPC Upload", icon: UploadCloud, mod: "dpc", admin: true },
  { to: "/stock", label: "Stock & Ageing", icon: Boxes, end: true, mod: "stock", notManager: true },
  { to: "/stock/branch", label: "Branch Stock", icon: Warehouse, mod: "stock" },
  { to: "/stock/locator", label: "Stock Locator", icon: PackageSearch, mod: "stock" },
  { to: "/stock/velocity", label: "Retail Velocity", icon: Zap, mod: "stock" },
  { to: "/stock/banks", label: "Funding Banks", icon: Landmark, mod: "stock", show: canEditBanks },
  { to: "/stock/upload", label: "Stock Upload", icon: UploadCloud, mod: "stock", show: (u) => canUploadStock(u) || canUploadRetail(u) },
  { to: "/service/overview", label: "Service Overview", icon: Compass, mod: "service" },
  { to: "/service", label: "Service Cockpit", icon: Wrench, end: true, mod: "service" },
  { to: "/service/workshop", label: "Workshop Dashboard", icon: Gauge, mod: "service" },
  { to: "/service/open-ros", label: "Open RO Board", icon: Clock, mod: "service" },
  { to: "/service/benchmark", label: "Benchmark Explorer", icon: BarChart3, mod: "service" },
  { to: "/service/leaderboard", label: "Leaderboard", icon: Trophy, mod: "service" },
  { to: "/service/targets", label: "Targets", icon: Target, mod: "service", targetAdmin: true },
  { to: "/service/manpower", label: "Service Manpower", icon: Users, mod: "service" },
  { to: "/service/upload", label: "Service Upload", icon: UploadCloud, mod: "service", admin: true },
  { to: "/uploads", label: "Uploads", icon: Upload, mod: "system", admin: true },
  { to: "/admin", label: "Admin", icon: Settings, mod: "system", admin: true },
];

export const SECTION_LABELS = { mis: "Market intelligence", common: "Network", dpc: "Sales cockpit", stock: "Stock & ageing", service: "Service cockpit", system: "System" };

export const canManageTargets = (u) => !!u && (u.role === "admin" || (u.role === "vp" && u.department === "service"));
export const isServiceUser = (u) => !!u && u.department === "service" && u.role !== "admin";

export const visibleMods = (u) => {
  if (!u) return new Set();
  if (u.role === "admin" || u.role === "md") return new Set(["mis", "common", "dpc", "stock", "service", "system"]);
  if (u.role === "accounts") return new Set(["mis", "common", "dpc", "stock", "service"]);
  if (isStockIncharge(u)) return new Set(["stock"]);
  if (isServiceUser(u)) return new Set(["service"]);
  return new Set(["mis", "common", "dpc", "stock"]);
};

// MD, Sales VP and Zonal (regional) Heads land on the Sales Group Overview; Service VP / Zonal Heads on the Service Group Overview
export const isSalesLeader = (u) => !!u && (u.role === "md" || (u.department === "sales" && (u.role === "vp" || u.role === "zonal")));
export const isServiceLeader = (u) => !!u && u.department === "service" && (u.role === "vp" || u.role === "zonal");
export const homePath = (u) => (isServiceUser(u) ? (isServiceLeader(u) ? "/service/overview" : "/service") : isStockIncharge(u) ? "/stock" : isSalesLeader(u) ? "/dpc/overview" : "/");

export const navItemsFor = (u) => {
  const mods = visibleMods(u);
  return NAV.filter((n) => mods.has(n.mod) && (!n.admin || u?.role === "admin") && (!n.targetAdmin || canManageTargets(u)) && (!n.notManager || u?.role !== "manager") && (!n.show || n.show(u)));
};
